// extracted by mini-css-extract-plugin
module.exports = {"selected":"generalSearchTagsMobile_selected__3ebDH","container-tags":"generalSearchTagsMobile_container-tags__1WnhK","expand":"generalSearchTagsMobile_expand__zBFUa"};